import { I18nType } from '@affiliate-cabinet/i18n'

import { managerTranslationKeys } from '../../translations'
import { ManagerWorkingHoursType, ManagerWorkScheduleType } from '../../types'
import { getWorkingHours } from '../getWorkingHours'

export const getManagerWorkSchedule = ({
  i18n,
  workingHours,
}: {
  i18n: I18nType
  workingHours?: ManagerWorkingHoursType
}): ManagerWorkScheduleType | undefined => {
  if (!workingHours) {
    return undefined
  }

  return {
    days: i18n.t(managerTranslationKeys.managerDaysWork),
    hours: getWorkingHours({ locale: i18n.locale(), workingHours }),
  }
}
